module.exports = __webpack_public_path__ + "static/media/T4.4382ad9d.svg";